import CountryItem from "./CountryItem";

const countries: CountryItem[] = [
  {
    amazonUrl: "https://www.amazon.com",
    countryAbbreviation: "US",
    currency: "$",
  },
  {
    amazonUrl: "https://www.amazon.co.uk",
    countryAbbreviation: "GB",
    currency: "£",
  },
  {
    amazonUrl: "https://www.amazon.com.au",
    countryAbbreviation: "AU",
    currency: "$",
  },
  {
    amazonUrl: "https://www.amazon.ca",
    countryAbbreviation: "CA",
    currency: "$",
  },
];

export { countries };
